// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_GET_URL_IMPORT___ = require("../node_modules/css-loader/dist/runtime/getUrl.js");
var ___CSS_LOADER_URL_IMPORT_0___ = require("../static/images/services_line.png");
var ___CSS_LOADER_URL_IMPORT_1___ = require("../static/images/services_face.png");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(function(i){return i[1]});
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
var ___CSS_LOADER_URL_REPLACEMENT_1___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_1___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".sideDoodle_wkQiz{background:url(" + ___CSS_LOADER_URL_REPLACEMENT_0___ + ") 0 97% repeat-y!important}.sideDoodleLast_C7shT{background-image:url(" + ___CSS_LOADER_URL_REPLACEMENT_1___ + ")}.markdown_Rf2Cz p{line-height:1.75rem;margin-bottom:2rem}.markdown_Rf2Cz p:last-of-type{margin-bottom:0}.markdown_Rf2Cz p{font-feature-settings:\"ss10\" on,\"salt\" on,\"onum\" on}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"sideDoodle": "sideDoodle_wkQiz",
	"sideDoodleLast": "sideDoodleLast_C7shT",
	"markdown": "markdown_Rf2Cz"
};
module.exports = ___CSS_LOADER_EXPORT___;
